module.exports = "/virtual-football/img/btn-background-green.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/btn-background-green.png
// module id = 281
// module chunks = 6